export default __webpack_public_path__ + "static/media/qr_code.e6d973bd.jpg";